var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsolatedMonochromeBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-423bf9ae": "",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 60",
    className: "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-v-423bf9ae": "",
    id: "b7b33211-0572-4269-bbcb-cdaccc386d3a",
    transform: "matrix(1,0,0,1,-8,-2)",
    stroke: "none",
    fill: "black"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 46H27a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-1 6h-8v-4h8v4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 5v3H9a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h.246L15 35.139V40h-2a1 1 0 0 0-1 1v12c0 2.757 2.243 5 5 5v4h2v-4h26v4h2v-4c2.757 0 5-2.243 5-5V41a1 1 0 0 0-1-1h-2v-4.861L54.754 15H55a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-4V5h-2v3H33V6h8V4h-8V2h-2v2h-8v2h8v2H15V5h-2zm14.79 29l-4.524-19h17.468L36.21 34h-8.42zm-6.58-19l4.524 19h-8.98l-5.429-19h9.885zM14 48h7v4h-7v-4zm29 4v-4h7v4h-7zm7-6h-8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.816A2.996 2.996 0 0 1 47 56H17a2.996 2.996 0 0 1-2.816-2H22a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-8v-4h36v4zm-33-6v-4h30v4H17zm30.246-6h-8.98l4.524-19h9.885l-5.429 19zM54 13H10v-3h44v3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.293 22.293l4-4 1.414 1.414-4 4zM28.293 28.293l4-4 1.414 1.414-4 4zM33.293 23.293l2-2 1.414 1.414-2 2zM42.292 26.293l5-5 1.414 1.415-5 5zM16.293 26.293l4-4 1.414 1.414-4 4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsolatedMonochromeBlack);
export default __webpack_public_path__ + "static/media/isolated-monochrome-black.f82275c3214f2cbb72b49dac0e317f1e.svg";
export { ForwardRef as ReactComponent };